export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUPER_ADMIN = 'LOGIN_USER_SUPER_ADMIN';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_AVATAR = 'UPDATE_USER_AVATAR';
export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
